'use client';

import { useEffect, useRef } from 'react';

import { trackEvent } from '../core';

import type { EventData } from '../types';

export const useTrackEventOnce = (event: EventData | undefined) => {
  const tracked = useRef(false);

  useEffect(() => {
    if (tracked.current || typeof event === 'undefined') {
      return;
    }

    tracked.current = true;

    trackEvent(event);
  }, [event]);
};
